module.exports = __webpack_public_path__ + "static/media/dineInMenu.0a75260b.pdf";